(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 33539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _src_components_atom_Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96538);
/* harmony import */ var _src_features_auth_useAuth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37671);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);






var GameSearchComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(4938), __webpack_require__.e(4582)]).then(__webpack_require__.bind(__webpack_require__, 64582));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_src_components_atom_Loading__WEBPACK_IMPORTED_MODULE_2__/* .LoadingComponent */ .NF, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(64582)];
    }
  }
});
var GameCategoryComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(8043), __webpack_require__.e(6840)]).then(__webpack_require__.bind(__webpack_require__, 98924));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_src_components_atom_Loading__WEBPACK_IMPORTED_MODULE_2__/* .LoadingComponent */ .NF, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(98924)];
    }
  }
});
var GameLotteryResultComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(8043), __webpack_require__.e(8474)]).then(__webpack_require__.bind(__webpack_require__, 6735));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_src_components_atom_Loading__WEBPACK_IMPORTED_MODULE_2__/* .LoadingComponent */ .NF, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(6735)];
    }
  }
});
var AnnouncementComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1228), __webpack_require__.e(5896)]).then(__webpack_require__.bind(__webpack_require__, 96338));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_src_components_atom_Loading__WEBPACK_IMPORTED_MODULE_2__/* .LoadingComponent */ .NF, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(96338)];
    }
  }
});
var AuthSectionComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 8748).then(__webpack_require__.bind(__webpack_require__, 58748));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_src_components_atom_Loading__WEBPACK_IMPORTED_MODULE_2__/* .LoadingComponent */ .NF, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(58748)];
    }
  }
});
var JackpotProgressComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 7938).then(__webpack_require__.bind(__webpack_require__, 37938));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_src_components_atom_Loading__WEBPACK_IMPORTED_MODULE_2__/* .LoadingComponent */ .NF, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(37938)];
    }
  }
});
var RealtimeTransactionComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1228), __webpack_require__.e(4617), __webpack_require__.e(8043), __webpack_require__.e(4424)]).then(__webpack_require__.bind(__webpack_require__, 35770));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_src_components_atom_Loading__WEBPACK_IMPORTED_MODULE_2__/* .LoadingComponent */ .NF, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(35770)];
    }
  }
});
var GamepopularComponent2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 6626).then(__webpack_require__.bind(__webpack_require__, 26626));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_src_components_atom_Loading__WEBPACK_IMPORTED_MODULE_2__/* .LoadingComponent */ .NF, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(26626)];
    }
  }
});
var GameRecommendedComponent2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 6009).then(__webpack_require__.bind(__webpack_require__, 86009));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_src_components_atom_Loading__WEBPACK_IMPORTED_MODULE_2__/* .LoadingComponent */ .NF, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(86009)];
    }
  }
});
var GameProviderComponent2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 9394).then(__webpack_require__.bind(__webpack_require__, 89394));
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_src_components_atom_Loading__WEBPACK_IMPORTED_MODULE_2__/* .LoadingComponent */ .NF, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(89394)];
    }
  }
});

var Home = function Home() {
  var _useAuth = (0,_src_features_auth_useAuth__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
      isLoggedIn = _useAuth.isLoggedIn;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(['announcement', 'authSection', 'gamecategory', // 'jackpotprogress'
  'gamesearch', 'gameprovider', // 'gamelotteryresult',
  'gamePopular', 'gamerecommended', 'realtimetransaction']),
      brandSectionOrder = _useState[0];

  var sectionOrderComponent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return brandSectionOrder.map(function (item, index) {
      var sectionSlideMode = index % 2 === 0 ? 'fromLeft' : 'fromRight';
      var component;

      switch (item) {
        // case 'banner':
        // 	component = <BannerMain slideMode={sectionSlideMode} />;
        // 	break;
        case 'authSection':
          if (!isLoggedIn) component = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(AuthSectionComponent, {
            className: "mb-section"
          });
          break;

        case 'announcement':
          component = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(AnnouncementComponent, {});
          break;

        case 'gamecategory':
          component = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(GameCategoryComponent, {});
          break;

        case 'gamesearch':
          component = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: "hidden md:block",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(GameSearchComponent, {
              slideMode: sectionSlideMode
            })
          });
          break;

        case 'gameprovider':
          component = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(GameProviderComponent2, {});
          break;

        case 'gamelotteryresult':
          component = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(GameLotteryResultComponent, {
            slideMode: sectionSlideMode,
            showTitle: true
          });
          break;

        case 'gamerecommended':
          component = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(GameRecommendedComponent2, {});
          break;

        case 'gamePopular':
          component = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(GamepopularComponent2, {});
          break;

        case 'realtimetransaction':
          component = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(RealtimeTransactionComponent, {});
          break;

        case 'jackpotprogress':
          component = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(JackpotProgressComponent, {});
          break;

        default:
          component = null;
          break;
      }

      return component ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: component
      }, index) : null;
    });
  }, [isLoggedIn]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: sectionOrderComponent
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Home);

/***/ }),

/***/ 96538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "NF": function() { return /* reexport */ LoadingComponent; },
  "$z": function() { return /* reexport */ LoadingRing; }
});

// UNUSED EXPORTS: LoadingPage

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/helpers/custom-image-loader.js
var custom_image_loader = __webpack_require__(99125);
// EXTERNAL MODULE: ./utils/cn.js
var utils_cn = __webpack_require__(8957);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/atom/Loading/LoadingComponent.jsx





var LoadingComponent = function LoadingComponent(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "w-full flex justify-center items-center",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (0,utils_cn.cn)('relative w-10 h-10 aspect-square', className),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/icons/loading/loading-2.gif",
          loader: custom_image_loader/* customImageLoader */.o,
          layout: "fill",
          objectFit: "contain",
          priority: true
        })
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/components/atom/Loading/LoadingPage.jsx




var LoadingPage = function LoadingPage(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_jsx("div", {
    className: "w-full h-screen flex justify-center items-center",
    children: /*#__PURE__*/_jsx("div", {
      className: cn('relative w-16 h-16 lg:w-32 lg:h-32 aspect-square', className),
      children: /*#__PURE__*/_jsx(Image, {
        src: "/icons/loading/loading-2.gif",
        loader: customImageLoader,
        layout: "fill",
        objectFit: "contain",
        priority: true
      })
    })
  });
};
;// CONCATENATED MODULE: ./src/components/atom/Loading/LoadingRing.jsx

var LoadingRing = function LoadingRing() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "w-full h-full rounded-full animate-spin border-2 border-solid border-black border-t-transparent"
  });
};
;// CONCATENATED MODULE: ./src/components/atom/Loading/index.jsx




/***/ }),

/***/ 99125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ customImageLoader; }
/* harmony export */ });
var customImageLoader = function customImageLoader(_ref) {
  var src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;
  return `${src}?w=${width}&q=${quality || 50}`;
}; // const customLoader = ({ src, width, quality }) => {
// 	return `${src}?w=${width}&q=${quality || 75}`;
// };
// export default customLoader;

/***/ }),

/***/ 8957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cn": function() { return /* binding */ cn; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90512);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27154);


function cn() {
  for (var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++) {
    inputs[_key] = arguments[_key];
  }

  return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_0__/* .twMerge */ .m6)((0,clsx__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .W)(inputs));
}

/***/ }),

/***/ 45728:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(33539);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7154,5675,9774,2888,179], function() { return __webpack_exec__(45728); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);